<template>
  <div>
    <div>
      <div
        v-if="resources.length && !isLoading"
        class="flex items-center"
      >
        <div class="w-1/2 md:w-4/5 input-group mb-0 mr-4">
          <input
            v-model="search"
            type="text"
            placeholder="Search Resources"
          >
        </div>
        <nav class="w-1/2 md:w-1/5">
          <div class="select-container">
            <select
              class="m-0"
              @change="mobileNavigation"
            >
              <option
                :selected="isFilteredToCategory(false)"
                :value="'clearFilteredCategory'"
                v-text="'All Resources'"
              />
              <option
                v-for="(availableCategory, index) in categories"
                :key="`category-${index}`"
                :selected="isFilteredToCategory(availableCategory)"
                :value="availableCategory"
                v-text="availableCategory"
              />
            </select>
          </div>
        </nav>
      </div>
      <div class="max-w-3xl flex-no-grow">
        <div
          v-for="(resourceGroup, index) in groupedResources"
          :key="`resource-group-${index}`"
        >
          <Resources
            v-if="resources.length && isVisible(resourceGroup)"
            :resources="resourceGroup"
            :category="resourceGroup[0].category.attributes.title"
          />
        </div>
        <div
          v-if="!resources.length && !isLoading"
          class="empty"
        >
          <section>
            <h2 v-text="'There are no created Resources'" />
            <p>
              Resources are pages and links that your members will need access to.
              <a
                target="_blank"
                rel="noopener noreferrer"
                :href="$root.baseSupportUrl"
                v-text="'Have a question about the way they work?'"
              />
            </p>
          </section>
        </div>
      </div>
    </div>
    <CreateLinkModal
      :show="$store.state.resource.createLinkModalIsOpen"
      @created="fetchResources"
    />
    <DeleteLinkModal
      :show="$store.state.resource.deleteLinkModal.open"
      @destroyed="fetchResources"
    />
    <DisableLinkModal
      :show="$store.state.resource.disableLinkModal.open"
      @disabled="fetchResources"
    />
    <EnableLinkModal
      :show="$store.state.resource.enableLinkModal.open"
      @enabled="fetchResources"
    />
    <EditLinkModal
      :show="$store.state.resource.editLinkModal.open"
      @updated="fetchResources"
    />
    <DeletePageModal
      :show="$store.state.resource.deletePageModal.open"
      @destroyed="fetchResources"
    />
    <DisablePageModal
      :show="$store.state.resource.disablePageModal.open"
      @disabled="fetchResources"
    />
    <EnablePageModal
      :show="$store.state.resource.enablePageModal.open"
      @enabled="fetchResources"
    />
  </div>
</template>

<script type="text/babel">
import CreateLinkModal from './_modals/CreateLinkModal'
import DeleteLinkModal from './_modals/DeleteLinkModal'
import DisableLinkModal from './_modals/DisableLinkModal'
import EnableLinkModal from './_modals/EnableLinkModal'
import EditLinkModal from './_modals/EditLinkModal'
import DeletePageModal from './_modals/DeletePageModal'
import DisablePageModal from './_modals/DisablePageModal'
import EnablePageModal from './_modals/EnablePageModal'
import Resources from './Resources'

export default {
  name: 'ResourceGroups',
  components: {
    Resources,
    CreateLinkModal,
    EnablePageModal,
    DisablePageModal,
    DeletePageModal,
    EditLinkModal,
    EnableLinkModal,
    DisableLinkModal,
    DeleteLinkModal,
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      isLoading: true,
      filteredToCategory: false,
      search: '',
    }
  },
  computed: {
    resources() {
      return this.disabled
        ? this.$store.state.resource.disabledResources.data
        : this.$store.state.resource.resources.data
    },
    groupedResources() {
      if (this.filteredResources) {
        return this.filteredResources.reduce((groups, resource) => {
          (groups[resource.category.attributes.title] = groups[resource.category.attributes.title] || []).push(resource)

          return groups
        }, {})
      }

      return []
    },
    filteredResources() {
      if (this.resources.length) {
        return this.resources.filter((resource) => {
          const name = resource.attributes.title.toLowerCase()

          return name.includes(this.search.toLowerCase())
        })
      }

      return null
    },
    categories() {
      const grouped = this.resources.reduce((groups, resource) => {
        (groups[resource.category.attributes.title] = groups[resource.category.attributes.title] || []).push(resource)

        return groups
      }, {})

      return Object.keys(grouped)
    },
  },
  async mounted() {
    await this.$nextTick()

    this.fetchResources()
  },
  methods: {
    fetchResources() {
      if (this.disabled) {
        this.$store.dispatch('resourceGetDisabledResources')
          .then(() => {
            this.isLoading = false
          })
      } else {
        this.$store.dispatch('resourceGetActiveResources')
          .then(() => {
            this.isLoading = false
          })
      }
    },
    setFilteredToCategory(category) {
      this.filteredToCategory = category
    },
    isVisible(resources) {
      return this.filteredToCategory === false || resources[0].category.attributes.title === this.filteredToCategory
    },
    clearFilteredToCategory() {
      this.filteredToCategory = false
    },
    isFilteredToCategory(category) {
      return category === this.filteredToCategory
    },

    mobileNavigation(e){
      if(e.target.value === 'clearFilteredCategory') {
        return this.clearFilteredToCategory()
      }

      return this.setFilteredToCategory(e.target.value)
    },
  },
}
</script>
